// Navegación: mega menú (hover/focus/teclado, Escape) y overlay móvil
// (foco contenido, Escape, scroll bloqueado). Spec §12.7–12.8.

const FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

function setupMegaMenu() {
	const item = document.querySelector(".psyque-nav__item--has-mega");
	const trigger = document.querySelector("[data-mega-trigger]");
	const panel = document.querySelector("[data-mega-panel]");
	if (!item || !trigger || !panel) return;

	let closeTimer = null;

	const open = () => {
		clearTimeout(closeTimer);
		panel.hidden = false;
		// Deja que el navegador pinte el estado oculto antes de transicionar.
		requestAnimationFrame(() => panel.classList.add("is-open"));
		trigger.setAttribute("aria-expanded", "true");
	};

	// El cierre se aplaza: al bajar del enlace al panel el puntero cruza un
	// hueco y saldría del elemento. Con la espera, volver a entrar cancela
	// el cierre y el panel no parpadea.
	const close = (immediate = false) => {
		clearTimeout(closeTimer);
		if (immediate) {
			trigger.setAttribute("aria-expanded", "false");
			panel.classList.remove("is-open");
			panel.hidden = true;
			return;
		}
		closeTimer = setTimeout(() => {
			trigger.setAttribute("aria-expanded", "false");
			panel.classList.remove("is-open");
			setTimeout(() => {
				if (trigger.getAttribute("aria-expanded") === "false") panel.hidden = true;
			}, 200);
		}, 150);
	};

	item.addEventListener("mouseenter", open);
	item.addEventListener("mouseleave", () => close());

	// Teclado: el enlace navega con Enter; el panel se abre con foco dentro.
	trigger.addEventListener("focus", open);
	item.addEventListener("focusout", (event) => {
		if (!item.contains(event.relatedTarget)) close();
	});

	document.addEventListener("keydown", (event) => {
		if (event.key === "Escape" && trigger.getAttribute("aria-expanded") === "true") {
			close(true);
			trigger.focus();
		}
	});
}

function setupMobileNav() {
	const toggle = document.querySelector("[data-nav-toggle]");
	const overlay = document.querySelector("[data-mobile-nav]");
	if (!toggle || !overlay) return;

	const closeButton = overlay.querySelector("[data-nav-close]");
	let previousFocus = null;

	const open = () => {
		previousFocus = document.activeElement;
		overlay.hidden = false;
		document.body.classList.add("psyque-nav-open");
		toggle.setAttribute("aria-expanded", "true");
		closeButton?.focus();
	};

	const close = () => {
		overlay.hidden = true;
		document.body.classList.remove("psyque-nav-open");
		toggle.setAttribute("aria-expanded", "false");
		if (previousFocus instanceof HTMLElement) previousFocus.focus();
	};

	toggle.addEventListener("click", open);
	closeButton?.addEventListener("click", close);

	overlay.addEventListener("keydown", (event) => {
		if (event.key === "Escape") {
			close();
			return;
		}
		// Foco contenido dentro del overlay.
		if (event.key === "Tab") {
			const focusables = overlay.querySelectorAll(FOCUSABLE);
			if (!focusables.length) return;
			const first = focusables[0];
			const last = focusables[focusables.length - 1];
			if (event.shiftKey && document.activeElement === first) {
				event.preventDefault();
				last.focus();
			} else if (!event.shiftKey && document.activeElement === last) {
				event.preventDefault();
				first.focus();
			}
		}
	});
}

export function initNavigation() {
	setupMegaMenu();
	setupMobileNav();
}
